"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const EventNotFound_1 = __importDefault(require("../../sample/EventNotFound"));
const TriggerTestingDirections_1 = __importDefault(require("../../sample/TriggerTestingDirections"));
const SkippedTriggerTestMessage_1 = __importDefault(require("../../sample/SkippedTriggerTestMessage"));
const MultiSamplePicker_1 = require("../../sample/MultiSamplePicker");
const UnhandledSampleStateMessage_1 = __importDefault(require("../../sample/UnhandledSampleStateMessage"));
const components = {
    data: MultiSamplePicker_1.MultiSamplePicker,
    nodata: EventNotFound_1.default,
    directions: TriggerTestingDirections_1.default,
    waiting: TriggerTestingDirections_1.default,
    skipped: SkippedTriggerTestMessage_1.default,
};
function TriggerTestingView(props) {
    const { perStateProps, state } = props, customProps = __rest(props, ["perStateProps", "state"]);
    const Component = components[state];
    const componentProps = perStateProps[state] || {};
    return Component ? (react_1.default.createElement(Component, Object.assign({}, componentProps, customProps))) : (react_1.default.createElement(UnhandledSampleStateMessage_1.default, { state: state }));
}
exports.default = TriggerTestingView;
